import { Injectable } from "@angular/core";
import { JQueryHTTPClient } from "app/rest/JQueryHTTPClient";
import { EntityService } from "app/rest/entity.service";
import { Rest } from "app/rest/rest_client";

@Injectable()
export class SanctionReasonService extends EntityService<Rest.SanctionReason> {
    client: Rest.RestApplicationClient;
    constructor(private jquery: JQueryHTTPClient) {
        super();
        this.client = new Rest.RestApplicationClient(jquery);
    }

    create(arg0: Rest.SanctionReason): Rest.RestResponse<Rest.SanctionReason> {
        try {
            return this.client.SanctionReason_create(arg0);
        } catch (error) {
            console.error("Error creating SanctionReason:", error);
            throw error;
        }
    }

    update(arg0: Rest.SanctionReason): Rest.RestResponse<Rest.SanctionReason> {
        try {
            return this.client.SanctionReason_update(arg0);
        } catch (error) {
            console.error("Error updating SanctionReason:", error);
            throw error;
        }
    }

    getPage(
        arg0: Rest.ListPaginationRequest,
        queryParams?: { includeDisabled?: boolean }
    ): Rest.RestResponse<Rest.Page<Rest.SanctionReason>> {
        try {
            return this.client.SanctionReason_getPage(arg0, queryParams);
        } catch (error) {
            console.error("Error getting SanctionReason page:", error);
            throw error;
        }
    }

    changeStatus(
        arg0: number[],
        queryParams?: { status?: boolean }
    ): Rest.RestResponse<void> {
        try {
            return this.client.SanctionReason_changeStatus(arg0, queryParams);
        } catch (error) {
            console.error("Error changing SanctionReason status:", error);
            throw error;
        }
    }

    // @ts-ignore
    find(
        arg0: string,
        queryParams?: { id?: number }
    ): Rest.RestResponse<Rest.SanctionReason> {
        try {
            return this.client.SanctionReason_find(arg0, queryParams);
        } catch (error) {
            console.error("Error finding SanctionReason:", error);
            throw error;
        }
    }
}
